/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ExternalServicesModule
 */

import { CommonModule } from '@angular/common';
import { CoreModule } from 'ng/modules/core/core.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AviCardModule } from 'nsx-alb-ui-components';
import { SharedModule } from 'ng/shared/shared.module';
import { CustomerProgramComponent } from './components/customer-program';

/**
 * @description Angular Module for the Customer Program component
 * @author Shubam Bindal
 */
@NgModule({
    declarations: [CustomerProgramComponent],
    imports: [
        AviCardModule,
        SharedModule,
        CommonModule,
        CoreModule,
    ],
    exports: [
        CustomerProgramComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ExternalServicesModule {}
